
import * as React from 'react';
import { colors } from '../colors/color';
import { RadialChart } from './RadialChart';

type RadialAvgChartProps = {
    avg:number,
    dim?:string,
    fontSize?:string
}
export function RadialAvgChart(props:RadialAvgChartProps):JSX.Element
{
    const safeAvg = isNaN(props.avg) ? 0 : Math.max(0, Math.min(100, props.avg));
    const safeText = safeAvg.toFixed(1);

    return (
        <RadialChart
            color={colors.graphs.survey.getAnswerAverageColor(safeAvg)}
            fillPct={safeAvg*20}
            dim={props.dim}
            value={safeText}
            fontSize={props.fontSize} />
    );
}